import React from 'react'
import 'tachyons'
import './SearchBox.css'
const SearchBox = ({searchfield, searchChange}) => {
    return (
        <div className= "pa2 searchbox-div">
            <input 
                className= "pa3 br2 ba br-pill b--green searchbox"
                type='search' 
                placeholder='Search' 
                onChange={searchChange}
            />
        </div>
    )
}

export default SearchBox;